// extracted by mini-css-extract-plugin
export default {"root":"ClientDetailPage_root__QbSvI","clientDisplay":"ClientDetailPage_clientDisplay__RI6rj","users":"ClientDetailPage_users__AC-0I","user":"ClientDetailPage_user__CmLJx"};